import React from 'react';
import { AlertTriangle, X } from 'lucide-react';
import './confirm-dialog.scss';

interface Props {
  open: boolean;
  title: string;
  message: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/** Modal de confirmación (reemplaza a window.confirm). */
const ConfirmDialog: React.FC<Props> = ({
  open, title, message, confirmLabel = 'Confirmar', cancelLabel = 'Cancelar', danger, onConfirm, onCancel,
}) => {
  if (!open) return null;
  return (
    <div className="cd-overlay">
      <div className="cd-modal" onClick={e => e.stopPropagation()}>
        <button className="cd-close" onClick={onCancel} aria-label="Cerrar"><X size={18} /></button>
        <div className={`cd-icon ${danger ? 'danger' : ''}`}><AlertTriangle size={20} /></div>
        <h3 className="cd-title">{title}</h3>
        <div className="cd-text">{message}</div>
        <div className="cd-actions">
          <button className={`cd-confirm ${danger ? 'danger' : ''}`} onClick={onConfirm}>{confirmLabel}</button>
          <button className="cd-cancel" onClick={onCancel}>{cancelLabel}</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
